<template>
  <v-container fluid>

        <v-btn color="orange"
               small
               dark
               :disabled="!product.inventory"
               @click="addToCart(product)">
          Ajouter
        </v-btn>


  </v-container>


</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'AddToCart',
  props: {
    product: Object
  },
  methods: mapActions([
    'addToCart'
  ])
}
</script>
